'use client';

import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import { HeroInquiryTrigger } from './hero-inquiry-trigger';

function Title({ children }: { children: ReactNode }) {
  return (
    <h1 className="text-[28px] font-bold leading-[36px] tracking-[-0.544px] text-3b-text-primary md:text-[40px] md:leading-[48px] md:tracking-[-0.84px]">
      {children}
    </h1>
  );
}

function Description({ children }: { children: ReactNode }) {
  return (
    <p className="mt-1.5 text-base font-medium leading-[24px] tracking-[-0.176px] text-[#575C66] md:text-lg md:leading-[28px] md:tracking-[-0.256px]">
      {children}
    </p>
  );
}

function TitleFunnel() {
  const t = useTranslations('Support.funnel.hero');

  return (
    <section className="bg-white px-5 pb-[60px] pt-[140px] md:px-8 md:pb-[100px] md:pt-[208px]">
      <div className="flex flex-col items-center text-center 2xl:mx-auto 2xl:max-w-[960px]">
        <Title>{t('title')}</Title>
        <Description>{t('description')}</Description>
        <HeroInquiryTrigger />
      </div>
    </section>
  );
}

export default TitleFunnel;
